<script lang="ts">
    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'

    import Date from 'hydria/components/Date.svelte'

    export const nonSelectable: boolean = false
    interface Props {
        item: any
        isSelected?: boolean
        isPlaceholder?: boolean
    }

    let { item, isSelected = false, isPlaceholder = false }: Props = $props()
</script>

<style>
    .invisible {
        visibility: hidden;
    }
</style>

<span class:invisible={!isSelected || isPlaceholder}><Icon inline icon="fa:angle-right" /></span>
<Date value={item.stamp} format="h-table-s" />
